import React, { useEffect, useState } from 'react';
import { Icon, Popover } from 'porosys-ui';
import { useHistory } from 'react-router-dom';
import { Badge } from '@material-ui/core';
import MenuBar from './menu-bar';
import { authorizeUser } from '../../../../app/Login/api';
import { getUserNotificationsCount } from '../../../../app/Notification/api';
import NotificationList from '../../../../app/Notification/list/NotificationList';
import './styles.scss';

const MainHeader = props => {
    const [loggedInUser, setLoggedInUser] = useState(null);
    const [userMenuAnchor, setUserMenuAnchor] = useState(null);
    const [notificationsAnchor, setNotificationsAnchor] = useState(null);
    const [notificationsCount, setNotificationsCount] = useState(0);

    const history = useHistory();

    useEffect(() => {
        const fetchLoggedInUser = async () => {
            setLoggedInUser(await authorizeUser());
        };

        fetchLoggedInUser();

        const fetchUserNotificationsCount = async () => {
            setNotificationsCount(await getUserNotificationsCount());
        };

        fetchUserNotificationsCount();
    }, []);

    const handleLogOut = () => {
        localStorage.removeItem('token');
        history.push('/');
        window.location.reload();
    };

    const handleUserMenuOpen = event => {
        setUserMenuAnchor(event.currentTarget);
    };

    const handleUserMenuClose = () => {
        setUserMenuAnchor(null);
    };

    const handleNotificationsOpen = event => {
        setNotificationsAnchor(event.currentTarget);
    };

    const handleNotificationsClose = () => {
        setNotificationsAnchor(null);
    };

    const handledMarkedAsSeen = () => {
        setNotificationsCount(notificationsCount - 1);
    };

    const isUserMenuOpen = Boolean(userMenuAnchor);
    const isNotificationsOpen = Boolean(notificationsAnchor);

    return (
        <>
            {loggedInUser ? (
                <div className="main-header">
                    <div className="header-actions-bar">
                        <div className="header-item" onClick={handleUserMenuOpen}>
                            <Icon name="user" classes={{ root: 'icon' }} />
                        </div>

                        <Popover
                            classes={{ root: 'user-menu-container', paper: 'user-menu' }}
                            open={isUserMenuOpen}
                            anchorEl={userMenuAnchor}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            onClose={handleUserMenuClose}
                        >
                            <div className="menu-item">{loggedInUser.fullname}</div>
                            <div className="menu-item" onClick={handleLogOut}>
                                خروج
                            </div>
                        </Popover>

                        <div className="header-item" onClick={handleNotificationsOpen}>
                            <Badge className="header-badge" badgeContent={notificationsCount} color="secondary">
                                <Icon name="bell" classes={{ root: 'icon' }} />
                            </Badge>
                        </div>

                        <Popover
                            classes={{ root: 'notifications-container', paper: 'notifications' }}
                            open={isNotificationsOpen}
                            anchorEl={notificationsAnchor}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            onClose={handleNotificationsClose}
                        >
                            <NotificationList onMarkedAsSeenTrigger={handledMarkedAsSeen} />
                        </Popover>
                    </div>
                    <div className="menu-bar">
                        <MenuBar />
                    </div>
                </div>
            ) : (
                <br />
            )}
        </>
    );
};

export default MainHeader;
